<template>
    <div class="client-area-view">
        <section class="page-header py-5 bg-light">
            <div class="container">
                <h1 class="display-5 fw-bold">Strefa Klienta</h1>
                <p class="lead">Bezpieczny dostęp do dokumentów i komunikacja z biurem rachunkowym.</p>
            </div>
        </section>

        <section class="client-area-content py-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mx-auto" v-if="!isLoggedIn">
                        <div class="login-card p-4 bg-white rounded shadow-sm">
                            <h3 class="text-center mb-4">Zaloguj się do swojego konta</h3>

                            <form @submit.prevent="login">
                                <div class="mb-3">
                                    <label for="email" class="form-label">Adres email</label>
                                    <input type="email" class="form-control" id="email" v-model="loginForm.email"
                                        required>
                                </div>

                                <div class="mb-4">
                                    <label for="password" class="form-label">Hasło</label>
                                    <input type="password" class="form-control" id="password"
                                        v-model="loginForm.password" required>
                                </div>

                                <div class="d-flex justify-content-between align-items-center mb-4">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="remember"
                                            v-model="loginForm.remember">
                                        <label class="form-check-label" for="remember">
                                            Zapamiętaj mnie
                                        </label>
                                    </div>

                                    <a href="#" class="text-decoration-none">Zapomniałem hasła</a>
                                </div>

                                <div class="d-grid">
                                    <button type="submit" class="btn btn-primary btn-lg">Zaloguj się</button>
                                </div>

                                <div v-if="loginError" class="alert alert-danger mt-4">
                                    {{ loginError }}
                                </div>
                            </form>

                            <div class="mt-4 text-center">
                                <p>Nie masz jeszcze konta? <a href="#" class="text-decoration-none">Skontaktuj się z
                                        nami</a>, aby uzyskać dostęp.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" v-else>
                        <div class="logged-in-content">
                            <div class="welcome-header mb-5">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h2>Witaj, {{ user.name }}!</h2>
                                    <button class="btn btn-outline-danger" @click="logout">Wyloguj się</button>
                                </div>
                                <p class="text-muted">Ostatnie logowanie: {{ user.lastLogin }}</p>
                            </div>

                            <div class="nas-access-section p-4 bg-light rounded">
                                <h3 class="mb-4">Przesyłanie dokumentów</h3>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="card h-100">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fas fa-server me-2 text-primary"></i>
                                                    Dostęp do serwera NAS</h5>
                                                <p class="card-text">
                                                    Aby przesłać dokumenty, skorzystaj z bezpośredniego dostępu do
                                                    naszego serwera plików.
                                                    Po zalogowaniu, przejdź do folderu
                                                    <strong>fakturynaklientów</strong>.
                                                </p>
                                                <a href="https://contabilita.quickconnect.to" target="_blank"
                                                    class="btn btn-primary">
                                                    <i class="fas fa-external-link-alt me-2"></i> Otwórz serwer NAS
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card h-100">
                                            <div class="card-body">
                                                <h5 class="card-title"><i
                                                        class="fas fa-info-circle me-2 text-primary"></i> Informacje do
                                                    logowania</h5>
                                                <p class="card-text">
                                                    Aby zalogować się do serwera NAS, użyj tych samych danych logowania,
                                                    co do naszej aplikacji.
                                                    W razie problemów skontaktuj się z naszym działem obsługi.
                                                </p>
                                                <p><strong>Folder:</strong> /fakturynaklientów</p>
                                                <a href="mailto:pomoc@selam.pl" class="btn btn-outline-secondary">
                                                    <i class="fas fa-question-circle me-2"></i> Potrzebuję pomocy
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ClientAreaView',
    data() {
        return {
            isLoggedIn: false,
            loginForm: {
                email: '',
                password: '',
                remember: false
            },
            loginError: '',
            user: {
                name: 'Jan Kowalski',
                email: 'jan.kowalski@example.com',
                company: 'Kowalski sp. z o.o.',
                lastLogin: '24.03.2025, 10:15'
            }
        }
    },
    methods: {
        login() {
            // Symulacja logowania
            if (this.loginForm.email === 'demo@example.com' && this.loginForm.password === 'demo123') {
                this.isLoggedIn = true;
                this.loginError = '';
                this.user.email = this.loginForm.email;
            } else {
                this.loginError = 'Nieprawidłowy email lub hasło. Spróbuj ponownie.';
            }
        },
        logout() {
            this.isLoggedIn = false;
            this.loginForm = {
                email: '',
                password: '',
                remember: false
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.client-area-view {
    .page-header {
        background-color: #f1f8ff;

        h1 {
            color: var(--primary-color);
        }
    }

    .login-card {
        max-width: 500px;
        margin: 0 auto;

        h3 {
            color: var(--primary-color);
        }
    }

    .welcome-header {
        padding-bottom: 1rem;
        border-bottom: 1px solid #dee2e6;

        h2 {
            color: var(--primary-color);
            margin-bottom: 0.5rem;
        }
    }

    .nas-access-section {
        .card {
            transition: transform 0.3s ease;

            &:hover {
                transform: translateY(-5px);
            }
        }
    }
}
</style>